import React from "react"
import { motion } from "framer-motion"

const TablePagination = ({
  onPageChange,
  totalCount,
  page,
  from,
  to,
  totalPages,
  perPage,
  perPageOptions = [15, 25, 50, 100],
  onPerPageChange,
}) => {
  const getPaginationItems = () => {
    const items = []

    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1)
    }

    items.push(1)

    if (page > 4) {
      items.push("...")
    }

    const start = Math.max(2, page - 1)
    const end = Math.min(totalPages - 1, page + 1)

    for (let i = start; i <= end; i++) {
      items.push(i)
    }

    if (page < totalPages - 3) {
      items.push("...")
    }

    items.push(totalPages)

    return items
  }

  return (
    <div className="px-6 py-4 border-t border-gray-100 bg-gray-50/50 flex items-center justify-between flex-wrap gap-3">
      <div className="flex items-center gap-3">
        <span className="text-sm text-gray-500">
          Показано{" "}
          <span className="font-semibold text-gray-700">
            {from}–{to}
          </span>{" "}
          из <span className="font-semibold text-gray-700">{totalCount}</span>
        </span>

        {onPerPageChange && (
          <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5">
            {perPageOptions.map((n) => (
              <button
                key={n}
                type="button"
                onClick={() => n !== perPage && onPerPageChange(n)}
                className={`relative px-2.5 py-1 rounded-md text-xs font-semibold transition-colors
                  ${n === perPage ? "text-gray-900" : "text-gray-400 hover:text-gray-600"}`}
              >
                {n === perPage && (
                  <motion.span
                    layoutId="perPageActivePill"
                    transition={{ duration: 0.18, ease: "easeOut" }}
                    className="absolute inset-0 bg-white rounded-md shadow-sm"
                  />
                )}
                <span className="relative">{n}</span>
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="flex items-center gap-1">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => onPageChange((p) => Math.max(1, p - 1))}
          disabled={page === 1}
          className="p-2 rounded-xl border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </motion.button>

        {getPaginationItems().map((p, index) =>
          p === "..." ? (
            <span
              key={`dots-${index}`}
              className="w-9 h-9 flex items-center justify-center text-sm text-gray-500"
            >
              ...
            </span>
          ) : (
            <motion.button
              key={p}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => onPageChange(() => p)}
              className={`w-9 h-9 rounded-xl text-sm font-medium transition-all
                ${
                  p === page
                    ? "bg-blue-600 text-white shadow-md shadow-blue-200"
                    : "border border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
                }`}
            >
              {p}
            </motion.button>
          )
        )}

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => onPageChange((p) => Math.min(totalPages, p + 1))}
          disabled={page === totalPages}
          className="p-2 rounded-xl border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </motion.button>
      </div>
    </div>
  )
}

export default TablePagination
